module.exports = __webpack_public_path__ + "static/media/video-placeholder.a4117150.jpg";